export class AddCollectiveDto {
    name!: string;
}